import React from 'react'
import { Button, Alert, Dialog, DialogActions, DialogContent, DialogTitle, Divider, Typography, TextField } from '@mui/material';

const AddProjectDialog = ({
    openProjectModal,
    setOpenProjectModal,
    projectName,
    setProjectName,
    handleSubmitProject,
    setProjectError,
    projectError

}) => {

    return (
        <Dialog open={openProjectModal} onClose={() => setOpenProjectModal(false)} >
            <DialogTitle>Add New Project</DialogTitle>
            <Alert severity='warning' sx={{ width: 'auto', }}>
                This action will create a new CAR RPPB Project
            </Alert>
            <DialogContent sx={{ width: '500px' }}>
                <Divider sx={{ my: 1 }} />
                <Typography>Project Name</Typography>
                <TextField
                    name='projectName'
                    value={projectName}
                    onChange={e => setProjectName(e.target.value)}
                    fullWidth
                    sx={{ mb: 2 }}
                />
                {!!projectError && <Alert sx={{ mb: 1, width: '100%' }} severity="error">{projectError}</Alert>}
            </DialogContent>
            <DialogActions sx={{ mr: 'auto', mb: 3, ml: 2 }}>
                <Button variant='contained' onClick={handleSubmitProject}>
                    Add
                </Button>
                <Button variant='outlined' onClick={() => { setProjectError(null); setOpenProjectModal(false) }}>
                    Cancel
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export default AddProjectDialog